import { render, staticRenderFns } from "./SearchMovie.vue?vue&type=template&id=f0c31216&"
import script from "./SearchMovie.vue?vue&type=script&lang=js&"
export * from "./SearchMovie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports